import cn from 'classnames';
import noop from 'lodash/noop';
import { Link } from '@framework/router/Next/Link';
import { emailRegexp } from '@framework/ui/Organisms/FinalForm/validators/user/validateEmail';
import IconExternalLink from '@dealroadshow/uikit-icon/IconExternalLink';
import styles from './footerLink.module.scss';

interface IProps {
  path: string,
  children: React.ReactNode,
  className?: string,
  shouldOpenInNewTab?: boolean,
  isOpenInNewTabIcon?: boolean,
  onClick?: () => void,
}

const FooterLink = ({
  path,
  children,
  className,
  shouldOpenInNewTab = false,
  isOpenInNewTabIcon = true,
  onClick = noop,
}: IProps) => {
  const parsedPath = new URLSearchParams(path);
  const isLocalLink = (
    !shouldOpenInNewTab &&
    emailRegexp.test(path) &&
    (!parsedPath.get('hostname') || parsedPath.get('hostname') === window.location.hostname)
  );

  if (isLocalLink) {
    return (
      <Link
        to={ path }
        className={ cn(styles.link, className) }
        onClick={ onClick }
      >
        { children }
      </Link>
    );
  }

  return (
    <a
      href={ path }
      target={ shouldOpenInNewTab ? '_blank' : '_self' }
      rel={ shouldOpenInNewTab ? 'noopener' : '' }
      className={ cn(styles.link, className) }
      onClick={ onClick }
      suppressHydrationWarning
    >
      { children }
      { shouldOpenInNewTab && isOpenInNewTabIcon && (
        <IconExternalLink className={ styles.linkInNewTabIcon } />
      ) }
    </a>
  );
};

export default FooterLink;
